import * as t from './actionTypes';

const initialState = { isLoading: false, lotto: [] };

const lottoReducer = (state = initialState, action) => {

    switch (action.type) {
        case t.SET_BUSY:
            return Object.assign({}, state, { isLoading: true });

        case t.UNSET_BUSY:
            return Object.assign({}, state, { isLoading: false });

        case t.LOTTO_LOAD_SUCCESS:
            let { lotto } = action;

            return ({
                ...state,
                lotto: Object.keys(lotto).map(id => ({
                    ...lotto[id],
                    id,
                }))

            })

        default:
            return state;
    }
};

export default lottoReducer;
